const locale = {
  placeholder: 'Pilih waktu',
};

export default locale;
